<script setup lang="ts">
import { t } from '@/translations';
import { Switch } from '@headlessui/vue';

const model = defineModel<boolean>({ required: true });

const {
    label = '',
    trueLabel = '',
    falseLabel = '',
} = defineProps<{
    label?: string;
    trueLabel?: string;
    falseLabel?: string;
}>();
</script>

<template>
    <Switch
        v-model="model"
        :class="[
            'relative inline-flex h-8 w-[76px] shrink-0 cursor-pointer items-center rounded-xl p-1',
            'transition-colors duration-200 ease-in-out',
            'focus-visible:ring-secondary/60 focus:outline-hidden focus-visible:ring-2',
            model && 'bg-secondary',
            !model && 'bg-theme-blue-100',
        ]"
        data-test="switch-input"
    >
        <span v-if="label" class="sr-only">{{ label }}</span>
        <span
            aria-hidden="true"
            :class="[
                'text-theme-black pointer-events-none absolute top-1/2 -translate-y-1/2 text-sm font-semibold',
                model && 'left-3',
                !model && 'right-3',
            ]"
        >
            {{ model ? trueLabel || t('global.yes') : falseLabel || t('global.no') }}
        </span>
        <span
            aria-hidden="true"
            :class="[
                'pointer-events-none inline-block size-6 rounded-lg bg-white shadow-sm',
                'transition-transform duration-200 ease-in-out',
                model && 'translate-x-[44px]',
                !model && 'translate-x-0',
            ]"
        />
    </Switch>
</template>
